import { useEffect } from 'react'

/**
 * Show the browser's native "Leave site? changes may not be saved" prompt on
 * tab close / refresh / external navigation while `enabled` is true.
 *
 * The legacy editor layout got this for free from BoardLayout, but the V2
 * graph-editor layout renders outside BoardLayout and so lost it — letting
 * unsaved annotations vanish silently on reopen. The browser only
 * permits a warning here; it cannot autosave (use an in-app confirm for that).
 */
export function useBeforeUnloadWarning(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault()
      e.returnValue = ''
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [enabled])
}
